<template>
    <div class="container">
        <top></top>

        <list></list>

        <div class="major">
            <div class="main">
                <div class="Recruitment-Information">
                    <h2>
                        <span v-t="'recruitment_information'"></span>
                    </h2>
                    <div class="Job-requirements">
                        <ul>
                            <li>
                                <div class="li-main-top">
                                    <h3 v-t="'Linux_Software_Engineer'"></h3>
                                </div>
                                <div class="li-main-bottom">
                                    <h4 v-t="'Job_requirements'"></h4>
                                    <dl>
                                        <dt>
                                            <span>1.</span>
                                            <p v-t="'Linux_p1'"></p>
                                        </dt>
                                        <dt>
                                            <span>2.</span>
                                            <p v-t="'Linux_p2'"></p>
                                        </dt>
                                        <dt>
                                            <span>3.</span>
                                            <p v-t="'Linux_p3'"></p>
                                        </dt>
                                        <dt>
                                            <span>4.</span>
                                            <p v-t="'Linux_p4'"></p>
                                        </dt>
                                        <dt>
                                            <span>5.</span>
                                            <p v-t="'Linux_p5'"></p>
                                        </dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div class="li-main-top">
                                    <h3 v-t="'Android_Developer'"></h3>
                                </div>
                                <div class="li-main-bottom">
                                    <h4 v-t="'Job_requirements'"></h4>
                                    <dl>
                                        <dt>
                                            <span>1.</span>
                                            <p v-t="'Android_p1'"></p>
                                        </dt>
                                        <dt>
                                            <span>2.</span>
                                            <p v-t="'Android_p2'"></p>
                                        </dt>
                                        <dt>
                                            <span>3.</span>
                                            <p v-t="'Android_p3'"></p>
                                        </dt>
                                        <dt>
                                            <span>4.</span>
                                            <p v-t="'Android_p4'"></p>
                                        </dt>
                                        <dt>
                                            <span>5.</span>
                                            <p v-t="'Android_p5'"></p>
                                        </dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div class="li-main-top">
                                    <h3 v-t="'Machine_test_engineer'"></h3>
                                </div>
                                <div class="li-main-bottom">
                                    <h4 v-t="'Job_requirements'"></h4>
                                    <dl>
                                        <dt>
                                            <span>1.</span>
                                            <p v-t="'Test_p1'"></p>
                                        </dt>
                                        <dt>
                                            <span>2.</span>
                                            <p v-t="'Test_p2'"></p>
                                        </dt>
                                        <dt>
                                            <span>3.</span>
                                            <p v-t="'Test_p3'"></p>
                                        </dt>
                                        <dt>
                                            <span>4.</span>
                                            <p v-t="'Test_p4'"></p>
                                        </dt>
                                        <dt>
                                            <span>5.</span>
                                            <p v-t="'Linux_p5'"></p>
                                        </dt>
                                    </dl>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="Resume-delivery">
                    <p v-t="'Resume_delivery'"></p>
                    <p class="p2">zhaopin@mifidata.com</p>
                </div>
            </div>
        </div>

        <bottom></bottom>
    </div>
</template>

<script>
    import top from "../../components/common/Head";
    import list from "../../components/common/Nav";
    import bottom from "../../components/common/Foot";

    export default {
        name: "Recruit",

        components: {
            top,
            list,
            bottom,
        },
    }
</script>

<style scoped>
    .content img{
        width: 100%;
        height: 100%;
    }
    .Recruitment-Information{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
    }
    .Recruitment-Information h2{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 30px 0 0;
    }
    .Recruitment-Information h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Job-requirements{
        margin-top: 15px;
    }
    .Job-requirements ul li{
        margin: 60px 0  0;
        text-align: left;
    }
    .li-main-bottom h4{
        margin: 25px 0 10px;
    }
    .li-main-bottom dl dt{
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 5px 0;
    }
    .li-main-bottom dl dt span{
        margin-top: 5px;
        margin-right: 10px;
    }
    .li-main-bottom dl dt p{
        margin: 0;
    }
    .Resume-delivery{
        display: flex;
    }
    .Resume-delivery p{
        font-size: 18px;
        font-weight: bold;
        display: flex;
        align-items: center;
    }
    .Resume-delivery .p2{
        margin-left: 10px;
        color: #1B4F93;
    }
</style>